export default __webpack_public_path__ + "static/media/kangaroo.fc918e2a.png";